import { GroupVisitControllerApi, GroupVisitPatient } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  /** False keeps the patient booked in sessions already scheduled. */
  cancelUpcomingSessions: boolean;
  /** `patients` carries the ids to remove. */
  groupVisitPatient: GroupVisitPatient;
};

/**
 * Removes several patients from a group in one call.
 *
 * @author Rajkumar Rathod
 */
export const useRemoveGroupVisitPatients = () =>
  useMutationWithLoading(
    async ({
      groupVisitId,
      groupVisitPatient,
      cancelUpcomingSessions,
    }: Params) =>
      new GroupVisitControllerApi(
        getConfigObject()
      ).removePatientsFromGroupVisit(
        groupVisitId,
        groupVisitPatient,
        cancelUpcomingSessions,
        getXtenantId()
      )
  );
